<template>
    <component
            :is="tag"
            @click.stop="onClick"
            :class="classes"
            :style="{ 'font-size': size }"
            class="f-button inline-flex items-center justify-center focus:outline-none overflow-hidden no-underline hover:no-underline"
            :disabled="disable"
    >
        <img v-if="icon" :src="iconSrc" class="ltr:mr-2 rtl:ml-2 block text-black w-4 h-4"/>
        <slot/>
        <f-loading :showing="loading" overlay color="#FFFFFF"/>
    </component>
</template>

<script>
import { objectifyClasses } from '@/services/Utils'

export default {
  name: 'FButton',
  emits: ['click'],
  props: {
    rounded: Boolean,
    outline: Boolean,
    icon: String,
    size: String,
    loading: Boolean,
    disable: Boolean,
    disabledClass: String,
    buttonClasses: {
      type: [Object, Array, String],
      default () {
        return {}
      }
    },
    tag: {
      type: String,
      default: 'button'
    },
    padding: {
      type: [Object, Array],
      default () {
        return ['py-2', 'px-5']
      }
    }
  },
  computed: {
    iconSrc: function () {
      return new URL(`../assets/icons/${this.icon}.svg`, import.meta.url).href
    },
    classes: function () {
      return Object.assign({
        rounded: this.rounded,
        'bg-transparent border': this.outline,
        'font-bold': true,
        ...objectifyClasses(this.padding)
      }, objectifyClasses(this.buttonClasses))
    }
  },
  methods: {
    onClick (e) {
      if (this.disable) return
      this.$emit('click', e)
    }
  }
}
</script>

<style scoped lang="scss">
.f-button {
  // padding: .5em 1.25em;
  font-size: 14px;

  &__icon {
    margin-right: .5em;
    display: block;
    color: black;
    width: 1.4em;
    height: 1.4em;
  }
}
</style>
